module.exports = __webpack_public_path__ + "static/media/om_faceshape_v_vector.ffb2bbd1.svg";